import React from "react";
import ReactDOM from "react-dom/client";

import { Loading } from "@/components/molecules/Loading";

import QuoteDrawer from "./QuoteDrawer";
import "./main.css";
import { DrawerEvent } from "./quote/eventEnums";

const rootElement = document.querySelector("#quote-root");

if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <React.Suspense fallback={<Loading />}>
        <QuoteDrawer />
      </React.Suspense>
    </React.StrictMode>,
  );
}

const initOnlineBooking = () => {
  const buttons = document.querySelectorAll<HTMLButtonElement>(
    "[role='button'][data-target='#quote-drawer']",
  );

  if (buttons.length) {
    buttons.forEach((button) => {
      // Remove existing listener to avoid duplicates
      const newButton = button.cloneNode(true) as HTMLButtonElement;
      button.parentNode?.replaceChild(newButton, button);

      newButton.addEventListener("click", (e) => {
        e.preventDefault();
        const eventData = {
          packageId: newButton.dataset.packageId,
          groupSize: newButton.dataset.groupSize,
          arrivalDate: newButton.dataset.arrivalDate,
        };

        if (eventData.packageId) {
          window.postMessage({
            eventType: DrawerEvent.OPEN_DRAWER,
            event: eventData,
          });
        }
      });
    });
  }
};

initOnlineBooking();

// Listen for custom event to re-initialize after AJAX updates
document.addEventListener("reinitializeBookings", () => {
  initOnlineBooking();
});
